import { createContext, ReactNode, useContext } from 'react';

export type AppHeaderBackAction = {
  onClick: () => void;
  label?: string;
  ariaLabel?: string;
};

export type AppHeaderConfig = {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  showMenu?: boolean;
  sticky?: boolean;
  leftSlot?: ReactNode;
  centerSlot?: ReactNode;
  rightSlot?: ReactNode;
  secondaryRow?: ReactNode;
  backAction?: AppHeaderBackAction;
  variant?: 'default' | 'stacked' | 'compact';
  className?: string;
};

type AppHeaderContextValue = {
  setHeaderConfig: (config: AppHeaderConfig | null) => void;
};

const AppHeaderContext = createContext<AppHeaderContextValue | null>(null);

export const useAppHeader = (): AppHeaderContextValue => {
  const context = useContext(AppHeaderContext);
  if (!context) {
    throw new Error('useAppHeader must be used within AppHeaderProvider');
  }
  return context;
};

export const useOptionalAppHeader = (): AppHeaderContextValue | null => {
  return useContext(AppHeaderContext);
};

export const AppHeaderProvider = AppHeaderContext.Provider;
